export default __webpack_public_path__ + "static/registration-e77dc02b20a21cb8dc1e2ecab37dcd4a.png";